export default "__VITE_ASSET__B4a8Irjh__"